const AI_TOKEN_PARAM_KEYS = ['AItoken', 'aitoken', 'AIToken'];

export function getAiTokenFromSearch(search = typeof window !== 'undefined' ? window.location.search : '') {
  const params = search instanceof URLSearchParams ? search : new URLSearchParams(search || '');
  for (const key of AI_TOKEN_PARAM_KEYS) {
    const value = String(params.get(key) || '').trim();
    if (value) return value;
  }
  return '';
}

export function getSpaceViewBaseUrl() {
  const openUrl = typeof document !== 'undefined'
    ? document.getElementById('virtualRealityContainer')?.getAttribute('data-open-world-url')
    : '';
  let url;
  try {
    url = new URL(openUrl || window.location.href, window.location.origin);
  } catch (e) {
    url = new URL(window.location.href);
  }
  AI_TOKEN_PARAM_KEYS.forEach((key) => url.searchParams.delete(key));
  url.hash = '';
  return url.toString();
}

export function getAiTokenShareUrl(token) {
  const url = new URL(getSpaceViewBaseUrl(), window.location.origin);
  const value = String(token || '').trim();
  if (value) {
    url.searchParams.set('AItoken', value);
  }
  return url.toString();
}

export function copyTextToClipboard(text) {
  const value = String(text || '');
  if (navigator.clipboard?.writeText) {
    return navigator.clipboard.writeText(value);
  }
  return new Promise((resolve, reject) => {
    try {
      const el = document.createElement('textarea');
      el.value = value;
      el.setAttribute('readonly', '');
      el.style.position = 'fixed';
      el.style.left = '-9999px';
      document.body.appendChild(el);
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);
      resolve();
    } catch (err) {
      reject(err);
    }
  });
}

export function canManageAiTokens(model) {
  return !!(
    model?.config?.isAdmin
    || model?.config?.isOwner
    || model?.config?.isContributor
    || model?.userIsOwner
    || model?.userIsContributor
  );
}

export function escapeHtml(value) {
  const div = document.createElement('div');
  div.textContent = value == null ? '' : String(value);
  return div.innerHTML;
}
